<template>
  <div style="background-color: #fff;">
    <div style="height:17px"></div>
    <div class="register">
      <div class="title">注册条款</div>
      <div class="line"></div>
      <div class="content">
        {{ content }}
      </div>
    </div>
    <div class="btn-ok" @click="back">确定</div>
  </div>
</template>
<script>
import { clause } from "../api/user.js";
export default {
  name: "clause",
  data() {
    return {
      content: ""
    };
  },
  methods: {
    back() {
      window.history.go(-1);
    }
  },
  mounted() {
    clause().then(res => {
      this.content = res.data.data;
    });
  }
};
</script>
<style scoped>
body {
  background: #ffffff;
}
.register {
  width: 335px;
  min-height: 533px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
  margin: 0 auto;
}
.register .title {
  height: 53px;
  line-height: 53px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
}
.register .line {
  height: 1px;
  border: 1px solid #f0f0f0;
  margin: 0 20px;
}
.register .content {
  padding: 0 20px;
  font-size: 15px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: justify;
  color: #333333;
  margin: 16px auto 56px auto;
  padding-bottom: 50px;
}

.btn-ok {
  width: 306px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #d01112;
  border-radius: 100px;
  color: #ffffff;
  font-size: 15px;
  margin: 51px auto;
}
.register {
  height: 100%;
}
</style>
